import { gql } from '@apollo/client'

const MEAL_IMAGE_DESCRIPTION = gql`
  query mealImageDescription($image: Upload, $imageSignedId: String) {
    mealImageDescription(image: $image, imageSignedId: $imageSignedId) {
      description
    }
  }
`

export default MEAL_IMAGE_DESCRIPTION
